<template>
  <div class="app-loading-state" :class="{ compact }">
    <div class="spinner-border text-danger" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <p class="mb-1 mt-3 font-weight-bold">{{ title }}</p>
    <small v-if="description" class="text-muted">{{ description }}</small>
  </div>
</template>

<script>
export default {
  name: "LoadingState",
  props: {
    title: { type: String, default: "Loading data..." },
    description: { type: String, default: "" },
    compact: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.app-loading-state {
  display: flex;
  min-height: 320px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #1f2d3d;
  text-align: center;
}

.app-loading-state.compact {
  min-height: 160px;
}
</style>
